export default __webpack_public_path__ + "static/media/Subtraction_06.0aaf897b.png";